import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ContainerWrapper, FlexCenter, FlexLeft, HrefCTA, ListUnstyled } from "../Utils";
import bannerLogoBig from "../../Images/min-1600-hero.jpg";
import bannerLogoSmall from "../../Images/max-600-hero.jpg";
import logo from "../../Images/logos/logo.png";
import "./index.css";


const screenSizes = {
  big: 1600,
  medium: 768,
  small: 600,
  divide: 700,
};
const HeroWrapper = styled.div`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  width: 100%;
  background-size: cover;
  background-position: 50% 50%;
  min-height: 50.5vh;
  overflow: hidden;
  
  @media (min-width: 600.1px) {
    background-image: url(${bannerLogoBig});
  }
  @media screen and (max-width: ${screenSizes.small}px) {
    background-image: url(${bannerLogoSmall});
  }
  @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px) {
      min-height: 40.5vh;
    }
  @media (max-width: ${screenSizes.divide}px) {
      min-height: 40.5vh;
  }
`;
const BannerText = styled.h1`
  font-size: 1.9vw;
  font-family: Helvetica;
  font-weight: 500;
  color: rgba(255,255,255,.9);
  line-height: 1.5;
  margin-top: 0;
  margin-bottom: 0;
  text-align: left;
  position: relative;
  left: -4.5rem;
  transition: all .3s ease-in;
   
    @media (max-width: ${screenSizes.divide}px) {
      left: -2rem;
    }
    @media (max-width: ${screenSizes.small}px) {
      font-size: 3vw;
    }

    @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px) {
      left: -1.5rem;
    }
  

  > span {
    font-size: 2.3vw;
    font-weight: 600;
    display: table;
    font-family: 'Open Sans';
    color: white;
    position: relative;
    left: 4.5rem;
    transition: all .3s ease-in;

      @media (max-width: ${screenSizes.divide}px) {
        left: 2rem;
      }
      @media (max-width: ${screenSizes.small}px) {
        font-size: 3.7vw;
      }
      @media only screen 
      and (min-device-width : 768px) 
      and (max-device-width : 1024px) {
        left: 1.5rem;
      }
  }
`;
const BannerCaption = styled(FlexCenter)`
  flex-direction: column;
  width: 100%;
  height: 20vh;
  position: relative;
  padding-bottom: 0.5rem;
  transition: all .3s ease-in;
  top: -6vh;
    @media (max-width: ${screenSizes.divide}px) {
      top: -4vh;
    }
    @media only screen 
    and (min-device-width : 768px) 
    and (max-device-width : 1024px) {
      top: -1vh;
    }
`;
const BannerNavLogo = styled(FlexLeft)`
  justify-self: flex-start;
  white-space: nowrap;
  width: 100%;
  min-height: 131px;
  transition: height .3s ease-out;

  img {
    width: 84px;
    height: auto;
    position: relative;
    top : 0px;

    @media (max-width: 767.97px) {
      width: 64px;
    }
  }
`;
export default class Hero extends Component {
  render() {
    return (
      <React.Fragment>
        <HeroWrapper>
          <ContainerWrapper>
            <nav className="w-100 navbar d-flex nav__row--2 pt-3">
              <BannerNavLogo>
                <Link to="/">
                  <img src={logo} alt="GERS - Grow early, rapidly and secxurely"/>
                </Link>
              </BannerNavLogo>
            </nav>
          </ContainerWrapper>                
        <BannerCaption>
          <BannerText>A global ecosystem to help ventures<span>Grow Early, Rapidly and Securely</span></BannerText>
          <HrefCTA top={4} href="/joinus" target="_blank" rel="noreferrer noopener">Join us!</HrefCTA>
        </BannerCaption>
        </HeroWrapper>
        <OfferItems />           
      </React.Fragment>
    );
  }
}

function OfferItems () {
  return (
    <div className="cert-links w-100 py-0">
      <ListUnstyled className="w-100 py-0 text-center my-0 hero__list">
        {/* <li key="0"><Link to="/services/ecosystem">Who We Are</Link></li> */}
        <li key="2"><Link to="/principles">Principles</Link></li>
        <li key="1"><Link to="/scalecamps">Scalecamps</Link></li>        
        {/* <li key="3"><Link to="/services/machine-learning">Machine Learning</Link></li> */}
        <li key="4"><Link to="/cybersecurity">Cybersecurity</Link></li>
        <li key="5"><Link to="/ecosystem">Ecosystem</Link></li>
        {/* <li key="6"><Link to="/services/alumni-resources">Resources</Link></li> */}
      </ListUnstyled>
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/Components/Banner/index.js